import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import { communityTourKey, parseCommunityTourState, withTourStorageFallback, type CommunityTourState, type TourStorageAdapter } from './communityTourState';

const local: TourStorageAdapter = {
  async getItem(key) { return localStorage.getItem(key); },
  async setItem(key, value) { localStorage.setItem(key, value); },
};
const native: TourStorageAdapter = {
  async getItem(key) { return (await Preferences.get({ key })).value; },
  async setItem(key, value) { await Preferences.set({ key, value }); },
};
const storage = () => Capacitor.isNativePlatform() ? withTourStorageFallback(native, local) : local;
const writes = new Map<string, Promise<void>>();

export async function readCommunityTour(userId: string) {
  try {
    await writes.get(userId);
    return parseCommunityTourState(await storage().getItem(communityTourKey(userId)));
  } catch { return null; }
}

export function saveCommunityTour(userId: string, state: CommunityTourState): Promise<void> {
  const next = (writes.get(userId) ?? Promise.resolve()).then(async () => {
    try { await storage().setItem(communityTourKey(userId), JSON.stringify(state)); }
    catch { /* Blocked device storage must not prevent access to the app. */ }
  });
  writes.set(userId, next);
  void next.then(() => { if (writes.get(userId) === next) writes.delete(userId); });
  return next;
}